import React from 'react'

const EbookForm = () => {
    return (
        <div className='card shadow'>
            <div className="space">
                <h3 className="center-hori" ><span className="highlight">Shift</span>Mindset Free Ebook</h3>
                <p className="text-sm-no-p">Learn 4 of the 9 Fundamentals to Contribute to your personal transformation in any area of your life & business.</p>
            </div>
            
            <form style={{borderRadius: '0.2rem'}} className="flexCol space bg-secondary validate">
                <div className="form-group">
                    <input type="text" className="form-control" name="NAME" id="mce-NAME" placeholder="Name" />
                </div>
                <div className="form-group">
                    <input type="email" className="form-control" name="EMAIL" placeholder="Email" id="mce-EMAIL" />
                </div>
                <button type="submit" className="btn btn-danger">Get Free Ebook Now</button>
            </form>
        </div>
    )
}

export default EbookForm;
